"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Check, Shield, Zap, Clock } from "lucide-react";
const benefits = [{
  icon: Check,
  title: "Accuracy & Compliance",
  description: "Ensure your financial records are accurate and compliant with the latest regulations."
}, {
  icon: Shield,
  title: "Secure & Reliable",
  description: "Bank-level encryption and automatic backups keep your data safe and accessible."
}, {
  icon: Zap,
  title: "Real-Time Insights",
  description: "Access up-to-date financial reports and dashboards from anywhere, anytime."
}, {
  icon: Clock,
  title: "Save Time",
  description: "Automate routine tasks and focus on growing your business with cloud efficiency."
}];
export default function KeyBenefits() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="key-benefits" ref={sectionRef} className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className="space-y-8">
            {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            const delay = i * 150;
            return <div key={i} data-index={i} className="flex items-start gap-6 group transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
              opacity: sectionVisible ? 1 : 0,
              transform: sectionVisible ? "translateY(0)" : "translateY(20px)",
              transitionDelay: sectionVisible ? `${delay}ms` : "0ms"
            }}>
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
                backgroundColor: sectionVisible ? "var(--color-primary-light)" : "var(--color-muted)",
                color: sectionVisible ? "var(--color-primary)" : "var(--color-muted-foreground)"
              }}>
                    <Icon className="w-6 h-6" strokeWidth={2} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-[22px] leading-[1.5] font-semibold mb-2 text-foreground">
                      {benefit.title}
                    </h3>
                    <p className="text-[16px] leading-[1.6] font-normal text-muted-foreground">
                      {benefit.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>

          {}
          <div ref={imageRef} className="relative" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "scale(1)" : "scale(0.95)",
          transition: "opacity var(--duration-medium) var(--ease-smooth), transform var(--duration-medium) var(--ease-smooth)"
        }}>
            <Card className="overflow-hidden border-none shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:scale-[1.02]">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/modern_workspace_cloud_accounting.png" alt="Modern workspace with cloud accounting solutions" className="w-full h-full object-cover" />
              </AspectRatio>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}